
<div class="pb-5">
  <div class="font-semibold">{{title}}</div>
  <div class="flex justify-start flex-wrap gap-3" #dropListContainer cdkDropListGroup>
    @if (!_items || _items.length === 0) {
      <div>Keine Dateien vorhanden</div>
    }
    @for (file of _items; track file; let i = $index) {
      <div cdkDropList [cdkDropListData]="i">
        <div class="flex flex-col justify-between shadow" cdkDrag [cdkDragDisabled]="!editMode" [cdkDragData]="i" (cdkDragEntered)="dragEntered($event)" (cdkDragMoved)="dragMoved($event)" (cdkDragDropped)="dragDropped($event)"><a class="block" [href]="file.url" target="_blank">
          @if (file.type === 'document') {
            <div>
              <!-- todo: icon unterscheidung wenn wir mehr als nur pdf erwarten (word docs etc - FA hat viele)--><i class="fas fa-file-pdf text-6xl p-1" [title]="file.url"></i>
            </div>
          }
          @if (file.type !== 'document') {
            <img [src]="file.url" [alt]="file.url" [width]="thumbnailSize">
          }</a>
          @if (editMode) {
            <div class="overlay"><i class="cursor-pointer text-red-700 text-lg far fa-trash-alt mr-2" title="Feld löschen" (click)="deleteFile($event, file)"></i></div>
          }
        </div>
      </div>
    }
  </div>
</div>